import React from 'react';
import { IntlProvider } from 'react-intl';
import { Provider as EufemiaProvider } from '@dnb/eufemia/shared';
import { useLanguage } from '@dnb/locale';
import Header from './components/Header/Header';
import { translations } from './i18n';
import { useHeaderStore } from '@dnb/header-controls';
import MenuButton from './components/MenuButton/MenuButton';

export default function HeaderWrapper() {
  const { locale } = useLanguage();

  return (
    <IntlProvider locale={locale} messages={translations[locale]}>
      <EufemiaProvider locale={locale}>
        <Header />
      </EufemiaProvider>
    </IntlProvider>
  );
}

HeaderWrapper.displayName = 'Header';
export { useHeaderStore, MenuButton };
